(() => {
  const selector = '[data-cg-v20-hero]';

  const mount = (root) => {
    if (!root || root.dataset.cgV20Mounted === 'true') return;
    root.dataset.cgV20Mounted = 'true';

    const toggle = root.querySelector('[data-cg-v20-toggle]');
    if (!toggle) return;

    const icon = toggle.querySelector('.cg-v20__motion-icon');
    const label = toggle.querySelector('.cg-v20__motion-label');
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    let manualPaused = false;
    let outsideViewport = false;

    const render = () => {
      const paused = manualPaused || outsideViewport || document.hidden;
      root.classList.toggle('is-motion-paused', paused);
      root.classList.toggle('is-motion-forced', reducedMotion && !manualPaused);
      toggle.setAttribute('aria-pressed', String(manualPaused));
      toggle.setAttribute('aria-label', manualPaused ? 'Play hero motion' : 'Pause hero motion');
      if (icon) icon.textContent = manualPaused ? '▶' : 'Ⅱ';
      if (label) label.textContent = manualPaused ? 'Play motion' : 'Pause motion';
    };

    const onToggle = () => {
      manualPaused = !manualPaused;
      render();
    };

    const onVisibility = () => render();
    toggle.addEventListener('click', onToggle);
    document.addEventListener('visibilitychange', onVisibility);

    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        outsideViewport = !entries[0]?.isIntersecting;
        render();
      }, { rootMargin: '120px 0px', threshold: 0.01 });
      observer.observe(root);
    }

    root.cgV20Cleanup = () => {
      toggle.removeEventListener('click', onToggle);
      document.removeEventListener('visibilitychange', onVisibility);
      observer?.disconnect();
      delete root.cgV20Cleanup;
    };

    render();
  };

  const mountAll = (scope = document) => scope.querySelectorAll(selector).forEach(mount);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelector(selector)?.cgV20Cleanup?.());
})();
